var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "gantt-filter", attrs: { type: "flex" } },
    [
      _c(
        "el-col",
        { staticClass: "filter-container", attrs: { span: 24 } },
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-position": "top",
                "label-width": "8em",
                inline: true,
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                { staticStyle: { width: "80px" } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("planning.tooltip.timeStepper"),
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "" },
                          on: { change: _vm.handleTimeStepperChanges },
                          model: {
                            value: _vm.timeStepper,
                            callback: function ($$v) {
                              _vm.timeStepper = $$v
                            },
                            expression: "timeStepper",
                          },
                        },
                        _vm._l(_vm.timeSteppers, function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: { label: item, value: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("truck.filter"),
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-select",
                          model: {
                            value: _vm.selectValue,
                            callback: function ($$v) {
                              _vm.selectValue = $$v
                            },
                            expression: "selectValue",
                          },
                        },
                        _vm._l(_vm.filters, function (filter, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.$t("planning.columns." + filter.label),
                              value: filter.key,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { width: "410px" } },
                [
                  _vm.selectValue !== "status" &&
                  _vm.selectValue !== "offDuty" &&
                  _vm.selectValue !== "truckCommodityType" &&
                  _vm.selectValue !== "cargo"
                    ? _c("el-input", {
                        staticClass: "w-100",
                        attrs: {
                          placeholder: _vm.$t(
                            "planning.placeholder.searchQuery"
                          ),
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.addFilter("input")
                          },
                        },
                        model: {
                          value: _vm.inputValue,
                          callback: function ($$v) {
                            _vm.inputValue = $$v
                          },
                          expression: "inputValue",
                        },
                      })
                    : _vm._e(),
                  _vm.selectValue === "status"
                    ? [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.switchValue
                                ? _vm.$t("planning.showDisabledTruck")
                                : _vm.$t("planning.showEnabledTruck"),
                              placement: "top",
                            },
                          },
                          [
                            _c("el-switch", {
                              model: {
                                value: _vm.switchValue,
                                callback: function ($$v) {
                                  _vm.switchValue = $$v
                                },
                                expression: "switchValue",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "ml-1",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.addFilter("switch")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("general.confirm")) + " "
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm.selectValue === "truckCommodityType"
                    ? [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "320px" },
                            attrs: { multiple: "" },
                            model: {
                              value: _vm.truckCommodityValue,
                              callback: function ($$v) {
                                _vm.truckCommodityValue = $$v
                              },
                              expression: "truckCommodityValue",
                            },
                          },
                          _vm._l(_vm.truckCommodityTypes, function (item) {
                            return _c("el-option", {
                              key: item,
                              attrs: {
                                label: _vm.$t("truckCommodityType." + item),
                                value: item,
                              },
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "ml-1",
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.addFilter("truckCommodityType")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("general.confirm")) + " "
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "el-form-item",
                { staticClass: "text-indigo-700 float-right" },
                [
                  _c("b", [
                    _c("i", [
                      _vm._v(
                        _vm._s(_vm.$t("general.totalOrders")) +
                          ": " +
                          _vm._s(_vm.currentPlanOrdersLen)
                      ),
                    ]),
                  ]),
                ]
              ),
              _c("el-form-item", { staticClass: "text-teal-700 float-right" }, [
                _c("b", [
                  _c("i", [
                    _vm._v(
                      _vm._s(_vm.$t("planning.totalTrucks")) +
                        ": " +
                        _vm._s(_vm.$trucks.length) +
                        ","
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-col", { attrs: { span: 24 } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$truckFilters.length > 0,
                expression: "$truckFilters.length > 0",
              },
            ],
            staticClass: "tag-container",
          },
          _vm._l(_vm.$truckFilters, function (filter, index) {
            return _c(
              "el-tag",
              {
                key: index,
                staticClass: "filter-tag",
                attrs: { closable: "", size: "mini" },
                on: {
                  close: function ($event) {
                    return _vm.handleCloseTag(filter)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("planning.columns." + filter.label)) +
                    ": "
                ),
                _vm._l(filter.value.split(","), function (item, index) {
                  return filter.key === "truckCommodityType"
                    ? _c("span", { key: item }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("truckCommodityType." + item)) +
                            " " +
                            _vm._s(
                              index !== filter.value.split(",").length - 1
                                ? ", "
                                : ""
                            ) +
                            " "
                        ),
                      ])
                    : _c("span", [_vm._v(_vm._s(filter.value))])
                }),
              ],
              2
            )
          }),
          1
        ),
      ]),
      _c(
        "el-col",
        { staticClass: "mt-2", attrs: { span: 24 } },
        [
          _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.$t("planning.placeholder.filterCargo"),
                placement: "top",
              },
            },
            [
              _c(
                "el-select",
                {
                  attrs: { size: "mini" },
                  on: { change: _vm.handleTruckHasCargo },
                  model: {
                    value: _vm.cargoTruckVal,
                    callback: function ($$v) {
                      _vm.cargoTruckVal = $$v
                    },
                    expression: "cargoTruckVal",
                  },
                },
                [
                  _c("el-option", { attrs: { value: null } }),
                  _vm._l(["nonEmptyTrucks", "emptyTrucks"], function (item) {
                    return _c("el-option", {
                      key: item,
                      attrs: {
                        label: _vm.$t("truckFilter." + item),
                        value: item,
                      },
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c("el-switch", {
            staticClass: "ml-3",
            attrs: {
              "active-text": _vm.$t("planning.enableAllTrucks"),
              "inactive-text": _vm.$t("planning.disableAllTrucks"),
            },
            model: {
              value: _vm.isLocalEnableAllTrucks,
              callback: function ($$v) {
                _vm.isLocalEnableAllTrucks = $$v
              },
              expression: "isLocalEnableAllTrucks",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }